<template>
  <div>
    <FormulateInput
        :uploader="customUploader"
        :capture="capture"
        :disabled="disabled"
        :is-admin-mode="isAdminMode"
        :key="element.uuid"
        v-bind="element"
        ref="imageUpload"
        @file-upload-complete="onImageUploadComplete"
        @file-upload-error="onImageUploadError"
        @file-removed="onFileRemoved"
        add-label="+ Foto's toevoegen"
    />

    <v-btn v-if="imageUploadHasError" color="secondary" outlined @click="retryImageUpload" class="mr-3">Opnieuw uploaden</v-btn>
    <v-btn v-if="imageUploadHasError" color="secondary" outlined @click="saveUploadedFile">Bestand(en) opslaan</v-btn>

  </div>
</template>

<script>
import eformHelpers from "@/mixins/eformHelpers";
import store from "@/plugins/store";
import {fileToBase64} from "@/plugins/fileUploadHelper";
import axios from "axios";
import _ from "lodash";

export default {
  mixins: [
    eformHelpers,
  ],
  props: {
    element: Object,
    values: Object,
    schema: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    isAdminMode: {
      type: Boolean,
      default: false,
    },
    formSettings: Object,
  },
  data() {
    return {
      imageUploadHasError: false,
    }
  },
  computed: {
    capture() {
      return _.get(this.element, ['useOnlyCamera']) ? 'capture' : false;
    },
    uploadUrl() {
      if (this.hdImages) {
        return '/api/file-upload/form-hd';
      }
      return '/api/file-upload/form';
    },
    badInternetMode() {
      return _.get(this.formSettings, ['bad_internet_mode']) === true
    },
    hdImages() {
      return _.get(this.element, ['hdImages']) === true
    },
    appOnline() {
      return store.getters.appOnline
    }
  },
  methods: {
    /**
     * Custom uploader, this overrides the default uploader of Vue Formulate.
     *
     * @param file
     * @param progress
     * @param error
     * @returns {Promise<undefined|[{url: string, base64: unknown, filename: *}]|any>}
     */
    async customUploader (file, progress, error) {
      try {

        if (!this.appOnline || this.badInternetMode) {
          // App is offline, or badInternetMode is enabled. Convert file to base64.
          console.log('File upload started (to base64). Filename: ' + file.name)
          let converted_file = fileToBase64(file, this.hdImages)
          console.log('File upload completed (to base64). Filename: ' + file.name)
          return converted_file;
        }

        // App is online. Upload file with axios to backend.
        console.log('File upload started (to server). Filename: ' + file.name)
        const formData = new FormData()
        formData.append('file', file)
        const axiosResult = await axios.post(this.uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progressEvent => {
            // Set progress to process callback
            progress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
          }
        })
        console.log('File upload completed (to server). Filename: ' + file.name)
        return await axiosResult.data

      }
      catch (err) {
        console.log(err)
        let filename = file.name ? file.name : 'unknown'
        error('Bestand kon niet geupload worden. Probeer het opnieuw. Filename: ' + filename)
      }
    },
    onImageUploadComplete() {
      // console.log('Image upload completed:', fileInfo); // If you want to log the file info, add the parameter 'fileInfo' to the function
    },
    onImageUploadError() {
      // console.log('Image upload error:', error); // If you want to log the error, add the parameter 'error' to the function
      this.imageUploadHasError = true;
    },
    onFileRemoved() {
      this.imageUploadHasError = false;
    },
    /**
     * This function finds the Vue file element within the FormulateInput component. Note: This contains the DOM file input.
     *
     * @returns {*}
     */
    findFormulateFileInput() {
      let fileRefChild = null;
      // Check if `this.$refs.imageUpload` exists and has `$children`
      if (this.$refs.imageUpload && this.$refs.imageUpload.$children) {
        // Loop through the $children to find the one with the $ref 'file'
        fileRefChild = Object.values(this.$refs.imageUpload.$children).find(
            (child) => child.$refs && child.$refs.file
        );
      }
      // Log if child was not found
      if (!fileRefChild) {
        console.error('No child with $ref `file` found.');
      }
      return fileRefChild;
    },
    async saveUploadedFile() {
      console.log('Saving uploaded file via Web Share API...');
      // Get the file input element
      let formulateFileInput = this.findFormulateFileInput();
      let domFileInput = formulateFileInput.$refs.file;
      // Get uploaded files
      const files = domFileInput.files;

      if (files.length === 0) {
        this.$toast.error("Er zijn geen bestanden geupload.");
        return;
      }

      // feature detecting navigator.canShare() also implies
      // the same for the navigator.share()
      if (!navigator.canShare) {
        this.$toast.error("Uw browser ondersteunt de Web Share API niet.");
        return;
      }

      if (navigator.canShare({files})) {
        try {
          await navigator.share({
            files,
          });
          // output.textContent = "Shared!";
        } catch (error) {
          this.$toast.error(`Error: ${error.message}`);
        }
      }
      else {
        this.$toast.error("Uw systeem ondersteunt het opslaan van deze bestanden niet.");
      }
    },
    retryImageUpload() {
      console.log('Retrying image upload...');
      this.imageUploadHasError = false;
      // Get the file input element
      let formulateFileInput = this.findFormulateFileInput();
      // Upload the file again
      formulateFileInput.handleFile();
    },
  }
}
</script>

<style lang="scss" scoped>

</style>